import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { getSiteType } from '../../../common/utils/analytics';

export function trackNothingFound(deviceType: TDevice | undefined) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Map',
    action: 'show_sopr',
    label: 'nothing_in_this_area',
    page: { pageType: 'Map', siteType: getSiteType(deviceType) },
  });
}
